module.exports = __webpack_public_path__ + "img/tree_left_layout_icon.831d6f7f.svg";